module.exports = __webpack_public_path__ + "img/ikon.8b3a2670.png";